(function () {
class $7fe6c79de323174a$export$2e2bcd8739ae039 {
    constructor(window){
        this.window = window;
    }
    initialize() {
        const document = this.window.document;
        this.documentElement = document.documentElement;
        this.modal = document.getElementById("certification-modal");
        document.getElementById("certification-button").addEventListener("click", ()=>{
            this.showModal(true);
        });
        document.getElementById("close-modal-button").addEventListener("click", ()=>{
            this.showModal(false);
        });
        document.getElementById("modal-background").addEventListener("click", ()=>{
            this.showModal(false);
        });
    }
    showModal(visible) {
        this.modal.classList.toggle("is-active", visible);
        this.documentElement.classList.toggle("is-clipped", visible);
    }
}


const $1567641c0f0b12e1$var$app = new (0, $7fe6c79de323174a$export$2e2bcd8739ae039)(window);
$1567641c0f0b12e1$var$app.initialize();

})();
//# sourceMappingURL=index.af0a1101.js.map
